import {z} from 'zod'

import {apiFetch} from 'src/api/fetch'

import {
    activeRentalSchema,
    type ConfirmRentalsOutInput,
    confirmRentalsOutRequestSchema,
    confirmRentalsOutResponseSchema,
} from './schemas'

export async function listActiveRentals({mine, yardId}: {mine: boolean; yardId: string | null}) {
    const params = new URLSearchParams()
    if (mine) {
        params.set('mine', 'true')
    }
    if (yardId) {
        params.set('yard_id', yardId)
    }
    const query = params.toString()
    const raw = await apiFetch<unknown>(`/rentals/active${query ? `?${query}` : ''}`)
    return z.array(activeRentalSchema).parse(raw)
}

export async function confirmRentalsOut(input: ConfirmRentalsOutInput) {
    const raw = await apiFetch<unknown>('/rentals/confirm-out', {
        method: 'POST',
        body: JSON.stringify(confirmRentalsOutRequestSchema.parse(input)),
    })
    return confirmRentalsOutResponseSchema.parse(raw)
}
